import { useRequest } from "@/shared/composables/useRequest.ts";
import { HttpClientService } from "@/shared/services/http_client/HttpClientService.ts";
import { SecurityRepository } from "@/app/security/repositories/SecurityRepository";

export function logoutController() {
  const repository: SecurityRepository = new SecurityRepository(new HttpClientService());

  return useRequest({
    fn: async (refreshToken: string) => await repository.logout(refreshToken),
  });
}
